export const getYouTubeEmbedURL = (videoId: string) => {
  return `https://www.youtube.com/embed/${videoId}`
}
